import { EducationalMaterial, EducationalMaterialQuery } from '@dreryk/egabinet-knowledge-base-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner } from '@dreryk/react-components';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

import { useGetEducationalMaterialTags } from '~libs.desktop.shared.educational-material';

type EducationalMaterialsRenderProps = {
   educationalMaterials: EducationalMaterial[];
};

type EducationalMaterialsProps = Readonly<{
   children: (renderProps: EducationalMaterialsRenderProps) => JSX.Element;
}>;

export const EducationalMaterialsLoader = (props: EducationalMaterialsProps): JSX.Element | null => {
   const { tags } = useGetEducationalMaterialTags();

   const {
      data: educationalMaterials,
      loading: educationalMaterialsLoading,
      error: educationalMaterialsError,
   } = useCqrsSearch<EducationalMaterial>(() => {
      const query = new EducationalMaterialQuery();

      if (tags.length) {
         query.tags = Slot.of(tags);
      }

      return query;
   }, paginations.all<EducationalMaterial>().orderedBy('creationDate', Direction.DESCENDING));

   if (educationalMaterialsLoading) {
      return <LoaderSpinner />;
   }

   if (educationalMaterialsError || !educationalMaterials) {
      return null;
   }

   return props.children({
      educationalMaterials: educationalMaterials,
   });
};
